<template>
  <section class="app-main" style="min-height: 100%">
    <Breadcrumb class="breadcrumb">
      <BreadcrumbItem v-for="(item,index)  in levelList"
      :key="item.path" :href="item.redirect||item.path">{{$t(item.meta.title)}}</BreadcrumbItem>
    </Breadcrumb>
    <transition name="fade" mode="out-in">
      <router-view></router-view>
    </transition>
  </section>
</template>
<script>
export default {
  name: 'AppMain',
  created () {
    this.getBreadcrumb()
  },
  data () {
    return {
      levelList: null
    }
  },
  methods: {
    getBreadcrumb () {
      let matched = this.$route.matched.filter(item => item.meta.title)
      const first = matched[0]
      if (first && (first.meta.title !== 'menu.home' || first.path !== '')) {
        matched = [{ meta: {title: 'menu.home'}, path: '/' }].concat(matched)
      }
      this.levelList = matched
    }
  },
  watch: {
    $route () {
      this.getBreadcrumb()
    }
  }
}
</script>
<style lang="scss" scoped>
  .app-main {
    padding-top: 50px;
  }
  .breadcrumb {
    margin: 10px;
  }
</style>



// WEBPACK FOOTER //
// AppMain.vue?20673f42